export const AVANZAMENTO_V2_PILOT_USERS = ["riccardo"];
export const AVANZAMENTO_V2_PILOT_ENABLED = true;

export function canUseAvanzamentoV2(userdata = {}) {
    if (!AVANZAMENTO_V2_PILOT_ENABLED) return false;
    return AVANZAMENTO_V2_PILOT_USERS.includes(userdata?.username);
}
